// extracted by mini-css-extract-plugin
module.exports = {"button":"style-module__button___3jWik"};